import { FloatingPortal, flip, shift, type Middleware } from "@floating-ui/react";
import { createContext, useContext, useEffect } from "react";

export const FloatingPortalContext = createContext<{ root: HTMLElement, window: Window }>({ root: document.body, window: window });

/** Modal windows (e.g. {@link AdvancedDragModal}) set `root` so `MITFloatingPortal` and bounds-aware tooltips share the same DOM subtree. */
export function useFloatingPortalContext(): { root: HTMLElement, window: Window } {
   return useContext(FloatingPortalContext);
}

/** Flip + shift inside `root` (modal). Empty when no modal root — caller usually adds viewport flip/shift separately. */
export function floatingBoundaryMiddleware(root: HTMLElement | null | undefined): Middleware[] {
   if (root == null) return [];
   return [flip({ boundary: root, padding: 8 }), shift({ boundary: root, padding: 8 })];
}

export function MITFloatingPortal(props: { children: React.ReactNode }) {
   const { root } = useFloatingPortalContext();

   return (
      <FloatingPortal root={root}>
         {props.children}
      </FloatingPortal>
   )
}


export function attachPrint(root: HTMLElement | null, window: Window) {
   console.log("Setting up print area effect", { root, window })
   const handlePrint = () => {
      console.log("Adding print area")
      root?.querySelectorAll(".AdvancedDragModal").forEach((e: Element) => {
         let elem = e as HTMLElement
         if (elem instanceof HTMLElement && elem.style.zIndex == "1000") {
            let printAreas = [...elem.getElementsByClassName("js_ADMprint")];
            printAreas.forEach((a) => {
               a.classList.add("js_printArea")
            })
            const removeAllPrintAreas = () => {
               let printAreas = [...root.getElementsByClassName("js_printArea")]
               printAreas.forEach((a) => {
                  a.classList.remove("js_printArea")
               })
               window.removeEventListener("afterprint", removeAllPrintAreas)
            }
            window.addEventListener("afterprint", removeAllPrintAreas)
         }
      });
   }

   window.addEventListener("beforeprint", handlePrint)
}

export function usePrintADMArea(root: HTMLElement | null, window: Window) {
   useEffect(() => {
      console.log("Setting up print area effect", { root, window })
      const handlePrint = () => {
         console.log("Adding print area")
         root?.querySelectorAll(".AdvancedDragModal").forEach((e: Element) => {
            let elem = e as HTMLElement
            if (elem instanceof HTMLElement && elem.style.zIndex == "1000") {
               let printAreas = [...elem.getElementsByClassName("js_ADMprint")];
               printAreas.forEach((a) => {
                  a.classList.add("js_printArea")
               })
               const removeAllPrintAreas = () => {
                  let printAreas = [...root.getElementsByClassName("js_printArea")]
                  printAreas.forEach((a) => {
                     a.classList.remove("js_printArea")
                  })
                  window.removeEventListener("afterprint", removeAllPrintAreas)
               }
               window.addEventListener("afterprint", removeAllPrintAreas)
            }
         });
      }

      window.addEventListener("beforeprint", handlePrint)
      return () => window.removeEventListener("beforeprint", handlePrint)
   }, [window, root])
}
